import get from "lodash/get";

import {Select} from "@/components/select/Select.tsx";
import {EnumItem} from "@/lib/queries/common.ts";
import {PSMetric} from "@/lib/queries/pagespeed";
import {AccountUser} from "@/lib/types/accounts.ts";
import {LineChart} from "@/pages/pagespeed/report/body/LineChart";

interface MetricsHistoryProps {
  choices: EnumItem[];
  metrics?: PSMetric[];
  series?: JSON;
  user: AccountUser;
  metricSelected: string;
  setMetricSelected: (m: string) => void;
}

export const MetricsHistory = ({
  metrics,
  choices,
  metricSelected,
  setMetricSelected,
  series,
  user,
}: MetricsHistoryProps) => {
  const metricChoices = choices.filter((m) => !["performance_score", "best_practices_score"].includes(m.value));
  const currentChoice = choices.find((m) => m.value === metricSelected);
  const selectedMetric = metrics?.find((m) => m.name === metricSelected);
  const metricSeries = get(series, metricSelected);
  return (
    <>
      <h5>{selectedMetric && selectedMetric.label} Time Trend</h5>
      {selectedMetric && <p>{selectedMetric.description}</p>}
      <div className="my-3 d-flex align-items-center metrics-toolbar">
        <div className="metric-select-container">
          <Select
            defaultValue={currentChoice}
            value={currentChoice}
            options={metricChoices}
            onChange={(v) => setMetricSelected(v?.value ?? "tbt")}
            isClearable={false}
          />
        </div>
      </div>
      <div className="metrics-graph">
        <LineChart series={[metricSeries]} labels={selectedMetric ? [selectedMetric] : []} user={user} />
      </div>
    </>
  );
};
